import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderAtgardBaseCommand } from "./ArbetsorderAtgardBaseCommand";

export class MoveAtgarderToNewArbetsorderCommand extends ArbetsorderAtgardBaseCommand {
    atgardGuids: string[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type  = "MoveAtgarderToNewArbetsorderCommand";

    constructor(arbetsorderId: number, atgardGuids: string[]) {
        super(MoveAtgarderToNewArbetsorderCommand.$type, CommandType.Delete);
        this.atgardGuids = atgardGuids;
        this.arbetsorderId = arbetsorderId;
    }
}
